import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import ButtonItem from './widgets/button-item';
var HelpGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(HelpGroup, _React$Component);
  var _super = _createSuper(HelpGroup);
  function HelpGroup() {
    _classCallCheck(this, HelpGroup);
    return _super.apply(this, arguments);
  }
  _createClass(HelpGroup, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/React.createElement("div", {
        className: 'btn-group editor-btn-group'
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        isRichEditor: true,
        text: t('Shortcut_help'),
        id: 'helpIcon',
        className: 'use-help-icon',
        icon: 'iconfont icon-use-help',
        onMouseDown: this.props.onHelpToggle
      }));
    }
  }]);
  return HelpGroup;
}(React.Component);
export default withTranslation('seafile-editor')(HelpGroup);